import WonderFestival from "../../components/wonder";
import PercentageFestival from "../../components/percentage";
import SpiralFestival from "../../components/spiral";
import { FESTIVAL_TYPE } from "../../types";

export const festivalTemplate = {
  [FESTIVAL_TYPE.WONDER]: WonderFestival,
  [FESTIVAL_TYPE.PERCENT]: PercentageFestival,
  [FESTIVAL_TYPE.STEPPED_AMOUNT]: SpiralFestival,
  [FESTIVAL_TYPE.STEPPED_COUNT]: SpiralFestival,
};
